/* eslint-disable */
import { HintsType } from '../ContactSearchPanelEnum';
export default {
  [HintsType.thirdPartyNoRecordsContent]:
    'Voer minstens {minimumLength} tekens of cijfers in om alle {sourceName}-records te doorzoeken.',
  [HintsType.noFilterOrSearchRecordsTitle]: 'Geen resultaten gevonden',
  [HintsType.noFilterOrSearchRecordsContent]:
    'Controleer de resultaten van andere bronnen of wijzig uw trefwoord.',
  [HintsType.searching]: 'Zoeken...',
  companyTabTitle: 'Bedrijf',
  personalTabTitle: 'Persoonlijk',
  direct: 'Direct',
  extension: 'Ext.',
  contact: 'Contactpersoon',
  mobile: 'Mobiel',
  company: 'Bedrijf',
  home: 'Thuis',
  home2: 'Thuis',
  other: 'Overig',
  business: 'Zakelijk',
  business2: 'Zakelijk',
  car: 'Auto',
  fax: 'Fax',
  assistant: 'Assistant',
  callback: 'Call-back',
  MobileNumber: 'Mobiel nummer',
  ContactNumber: 'Nummer contactpersoon',
  DirectNumber: 'Direct nummer',
  doNotCall: 'Niet bellen',
} as const;

// @key: @#@"[HintsType.thirdPartyNoRecordsContent]"@#@ @source: @#@"Enter at least {minimumLength} characters or digits to search all {sourceName} records."@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsTitle]"@#@ @source: @#@"No results found"@#@
// @key: @#@"[HintsType.noFilterOrSearchRecordsContent]"@#@ @source: @#@"Check results from other sources or change your keyword."@#@
// @key: @#@"[HintsType.searching]"@#@ @source: @#@"Searching..."@#@
// @key: @#@"companyTabTitle"@#@ @source: @#@"Company"@#@
// @key: @#@"personalTabTitle"@#@ @source: @#@"Personal"@#@
// @key: @#@"direct"@#@ @source: @#@"Direct"@#@
// @key: @#@"extension"@#@ @source: @#@"Ext"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"mobile"@#@ @source: @#@"Mobile"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"home"@#@ @source: @#@"Home"@#@
// @key: @#@"home2"@#@ @source: @#@"Home"@#@
// @key: @#@"other"@#@ @source: @#@"Other"@#@
// @key: @#@"business"@#@ @source: @#@"Business"@#@
// @key: @#@"business2"@#@ @source: @#@"Business"@#@
// @key: @#@"car"@#@ @source: @#@"Car"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"assistant"@#@ @source: @#@"Assistant"@#@
// @key: @#@"callback"@#@ @source: @#@"Callback"@#@
// @key: @#@"MobileNumber"@#@ @source: @#@"Mobile Number"@#@
// @key: @#@"ContactNumber"@#@ @source: @#@"Contact Number"@#@
// @key: @#@"DirectNumber"@#@ @source: @#@"Direct Number"@#@
// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
